'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _reactBootstrap = require('react-bootstrap');

var _components = {
	_$ImageUpload: {
		displayName: 'ImageUpload'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var ImageUpload = (function (_Component) {
	_inherits(ImageUpload, _Component);

	function ImageUpload(props) {
		_classCallCheck(this, _ImageUpload);

		_Component.call(this, props);
		this.uid = _uuid2['default'].v4();
		this.state = {
			busy: false,
			overed: false,
			files: [],
			value: props.value ? props.value.toJS() : null
		};
	}

	ImageUpload.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		this.setState({ value: nextProps.value ? nextProps.value.toJS() : null });
	};

	ImageUpload.prototype.componentDidMount = function componentDidMount() {
		var _this = this;

		this.uploader = new plupload.Uploader({
			runtimes: 'html5,html4',
			multi_selection: false,
			unique_names: true,
			drop_element: this.uid + "_dropzone",
			browse_button: this.uid + '_pickfiles',
			url: '/upload/image',
			filters: {
				max_file_size: '100mb',
				mime_types: [{ title: "Image files", extensions: "jpg,gif,png" }]
			},
			init: {
				FilesAdded: function FilesAdded(up, files) {
					plupload.each(files, function (file) {
						_this.handleFileAdd(file);
					});
					_this.startUpload();
				},

				FileUploaded: this.handleFileUploaded.bind(this),
				UploadProgress: this.handleUploadProgress.bind(this),
				UploadComplete: this.handleUploadComplete.bind(this),

				Error: function Error(up, err) {
					alert(err.message);
				}
			}
		});
		this.uploader.init();
	};

	ImageUpload.prototype.componentWillUnmount = function componentWillUnmount() {
		this.uploader.destroy();
	};

	ImageUpload.prototype.startUpload = function startUpload() {
		this.setState({ busy: true });
		this.uploader.start();
	};

	ImageUpload.prototype.handleFileAdd = function handleFileAdd(file) {
		this.state.files = [];
		this.state.files.push(file);
		this.forceUpdate();
	};

	ImageUpload.prototype.handleUploadProgress = function handleUploadProgress(up, file) {
		this.forceUpdate();
	};

	ImageUpload.prototype.handleFileUploaded = function handleFileUploaded(up, file, response) {
		response = JSON.parse(response.response);
		this.setState({ value: { th: response.th, file: response.file } });
	};

	ImageUpload.prototype.handleUploadComplete = function handleUploadComplete(up, files) {
		this.setState({ busy: false });
		var value = _immutable2['default'].fromJS(this.state.value);
		if (this.props.onChange) {
			this.props.onChange(value);
		}
		if (this.props.onBlur) {
			this.props.onBlur(value);
		}
	};

	ImageUpload.prototype.handleClick = function handleClick(e) {
		e.nativeEvent.stopImmediatePropagation();
	};

	ImageUpload.prototype.handleReset = function handleReset() {
		if (this.props.onChange) {
			this.props.onChange(null);
		}
		if (this.props.onBlur) {
			this.props.onBlur(null);
		}
	};

	ImageUpload.prototype.dragEnter = function dragEnter(e) {
		this.setState({ overed: true });
	};

	ImageUpload.prototype.dragLeave = function dragLeave(e) {
		this.setState({ overed: false });
	};

	ImageUpload.prototype.renderInput = function renderInput() {
		var _this2 = this;

		/*var files = this.state.files.map(file => {
  	return <span key={file.id}>{file.percent}%</span>
  });*/
		var p;
		if (this.state.files.length) {
			var file = this.state.files[0];
			if (file.status != plupload.DONE) {
				p = _react2['default'].createElement(_reactBootstrap.ProgressBar, { bsStyle: 'success', now: file.percent, label: '%(percent)s%' });
			}
		}

		var preview;
		if (this.state.value) {
			var style = {
				height: this.state.value.th.height,
				width: this.state.value.th.width
			};
			preview = _react2['default'].createElement(
				'div',
				null,
				_react2['default'].createElement('img', { src: this.state.value.th.url, style: style }),
				_react2['default'].createElement(
					'div',
					{ onClick: function () {
							return _this2.handleReset();
						}, style: { cursor: 'pointer', textAlign: 'left' } },
					' ',
					_react2['default'].createElement('span', { className: 'icon-cross' }),
					'odstranit'
				)
			);
		}

		return _react2['default'].createElement(
			'table',
			{ id: this.uid + '_dropzone', onClick: this.handleClick },
			_react2['default'].createElement(
				'tbody',
				null,
				_react2['default'].createElement(
					'tr',
					null,
					_react2['default'].createElement(
						'td',
						{ className: 'imageupload' },
						_react2['default'].createElement(
							'div',
							{ className: 'picturepreview' },
							preview
						),
						_react2['default'].createElement(
							'a',
							{ id: this.uid + '_pickfiles', className: 'btn btn-default btn-xs', href: 'javascript:;' },
							_react2['default'].createElement('i', { className: 'fa fa-folder-open-o' }),
							'  Vybrat soubor'
						)
					),
					_react2['default'].createElement(
						'td',
						{ className: _classnames2['default']('dropzone', { 'overed': this.state.overed }),
							onDragEnter: this.dragEnter.bind(this),
							onDrop: this.dragLeave.bind(this),
							onDragLeave: this.dragLeave.bind(this) },
						'Přetáhněte soubor sem'
					)
				),
				_react2['default'].createElement(
					'tr',
					null,
					_react2['default'].createElement(
						'td',
						{ colSpan: '2' },
						p
					)
				)
			)
		);
	};

	ImageUpload.prototype.renderError = function renderError() {
		return this.props.error ? _react2['default'].createElement("span", { className: "error-block", key: "error" }, this.props.error) : null;
	};

	ImageUpload.prototype.renderWrapper = function renderWrapper(children) {
		return this.props.wrapperClassName ? _react2['default'].createElement("div", { className: this.props.wrapperClassName, key: "wrapper" }, children) : children;
	};

	ImageUpload.prototype.renderFormGroup = function renderFormGroup(children) {
		var classes = {
			'form-group': false,
			'has-feedback': this.props.hasFeedback,
			'has-success': this.props.bsStyle === 'success',
			'has-warning': this.props.bsStyle === 'warning',
			'has-error': this.props.bsStyle === 'error'
		};
		classes[this.props.groupClassName] = this.props.groupClassName;

		return _react2['default'].createElement("div", { className: _classnames2['default'](classes) }, children);
	};

	ImageUpload.prototype.render = function render() {
		return this.renderFormGroup([this.renderWrapper([this.renderInput()]), this.renderError()]);
	};

	var _ImageUpload = ImageUpload;
	ImageUpload = _wrapComponent('_$ImageUpload')(ImageUpload) || ImageUpload;
	return ImageUpload;
})(_Component2['default']);

exports['default'] = ImageUpload;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-inputs/ImageUpload.js
 ** module id = 1013
 ** module chunks = 1
 **/